var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio-group',{class:{
  'justify-center': true,
  'radio-group': true,
  'extra-dense': this.$store.getters.isMobile
},attrs:{"row":"","dense":""},model:{value:(_vm.selectedDistrictType),callback:function ($$v) {_vm.selectedDistrictType=$$v},expression:"selectedDistrictType"}},_vm._l((_vm.districtTypes),function(n){return _c('v-radio',{key:n.value,attrs:{"data-cy":"type-select","dense":"","value":n.value},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',{staticClass:"radio-label text-uppercase font-weight-bold"},[_vm._v(" "+_vm._s(n.label)+" ")])]},proxy:true}],null,true)})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }